import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { QrcodeComponent } from '../dialogs/qrcode/qrcode.component';
import { MeterBulkUpdateDialog } from '../dialogs/meter-bulk-update/meter-bulk-update.component';
import { MeterData } from '../model/meter.model';
import { ApiService } from '../services/api.service';
import { Role } from '../model/role';

@Component({
  selector: 'app-meterdetails',
  templateUrl: './meterdetails.component.html',
  styleUrls: ['./meterdetails.component.scss'],
})
export class MeterdetailsComponent implements OnInit {
  displayedColumns: string[] = [
    'meterId',
    'customerId',
    'currentReading',
    'previousReading',
    'meterStatus',
    'actions'
  ];
  // Update-only form: meter_id and cust_id are read-only; only the current
  // reading is editable. previousReading is shown for reference.
  meter: MeterData = {
    meterId: null,
    meterStatus: 'active',
    customerId: null,
    currentReading: 0,
    previousReading: 0,
    qiyaasReading: null,
    serialNumber: null
  };
  enableButton: boolean = false;
  isSysAdmin: boolean = false;
  isCustomerCare: boolean = false;
  isAdmin: boolean = false;
  isLoading: boolean = false;
  searchValue: string = '';
  totalData: number = 0;
  pageSizes: number[] = [5, 10, 15, 25];
  dataSource = new MatTableDataSource<MeterData>(null);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  constructor(public dialog: MatDialog, private apiService: ApiService, private _snackBar: MatSnackBar) {}

  ngOnInit(): void {
    this.checkLoginType();
    this.getMeterData();
  }

  getMeterData() {
    this.isLoading = true;
    this.apiService.getMeterDetails(0, 15, this.searchValue).subscribe((data) => {
      this.totalData = data.totalItems;
      this.dataSource = new MatTableDataSource<MeterData>(data.meters);
      this.dataSource.sort = this.sort;
      this.isLoading = false;
    });
  }

  nextpage(event: PageEvent) {
    this.isLoading = true;
    this.apiService.getMeterDetails(event.pageIndex, event.pageSize, this.searchValue).subscribe((data) => {
      this.totalData = data.totalItems;
      this.dataSource = new MatTableDataSource<MeterData>(data.meters);
      this.dataSource.sort = this.sort;
      this.isLoading = false;
    });
  }

  // Server-side search by meter id or customer id.
  applyFilter(filterValue: string) {
    this.searchValue = (filterValue || '').trim();
    this.getMeterData();
  }

  checkLoginType() {
    const loggedInUser = window.localStorage.getItem('loggedInUser');
    this.apiService.getEmplyeeDetailsById(loggedInUser).subscribe((data) => {
      let roles = data.roles.map((role: Role) => role.roleName);
      if (roles.includes("customercare")) {
        this.isCustomerCare = true;
      }
      if (roles.includes("admin")) {
        this.isAdmin = true;
      }
      if (roles.includes("sysadmin")) {
        this.isSysAdmin = true;
      }
    });
  }

  // Load the selected row into the update form (meter_id / cust_id stay read-only).
  updateMeter(element: MeterData) {
    this.meter = { ...element };
  }

  // Save only the current reading. meter_id, cust_id and meter_status are
  // preserved server-side, so updating a reading never turns the meter off.
  saveMeter() {
    if (this.meter.meterId == null || Number(this.meter.meterId) <= 0) {
      this._snackBar.open('Select a meter to update first', 'Close', { duration: 3000 });
      return;
    }
    this.apiService.updateMeter(this.meter).subscribe(() => {
      this._snackBar.open('Meter updated successfully', 'Close', { duration: 3000 });
      this.getMeterData();
    });
  }

  openMeterBulkUpdateDialog(): void {
    const dialogRef = this.dialog.open(MeterBulkUpdateDialog, {
      width: '600px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getMeterData();
      }
    });
  }

  updateMeterStatus(meterData: MeterData) {
    const status = (meterData.meterStatus || '').toLowerCase();
    if (status === 'active') {
      meterData.meterStatus = 'inactive';
    } else if (status === 'inactive') {
      meterData.meterStatus = 'active';
    }
    this.apiService.enableMeter(meterData).subscribe((data) => {
      this._snackBar.open('Meter data updated successfully', 'Close', {
        duration: 3000
      });
    });
  }
}
